const multiAgent = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {}
};
export default multiAgent;
